import type { ChakraProps } from "@chakra-ui/react";

export const decorationTriangleStyles: ChakraProps["sx"] = {
  content: "''",
  position: "absolute",
  top: "100%",
  left: "50%",
  transform: "translateX(-50%)",
  borderLeft: "12px solid transparent",
  borderRight: "12px solid transparent",
  borderTop: "12px solid white",
};

export const firstItemStyles: ChakraProps["sx"] = {
  "&:nth-of-type(2)": {
    marginRight: "72px",
    w: 14,
    marginLeft: -1.5,
  },
};
